var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBlackIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 64.548,
    height: 64.184,
    viewBox: "0 0 64.548 64.184",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_519",
    "data-name": "Rectangle 519",
    width: 47.615,
    height: 46.623
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_27775",
    "data-name": "Group 27775",
    transform: "translate(64.548 40.376) rotate(150)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_27774",
    "data-name": "Group 27774",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_22100",
    "data-name": "Path 22100",
    d: "M10.021,0C3.031,3.092-1.093,10.368.254,16.535a9.7,9.7,0,0,0,8.7,7.652,9.046,9.046,0,0,0,8.881-5.972C19.669,13.271,16.157,7.491,10.9,6.6,9.68,6.389,7.648,5.74,7.576,5.113c-.141-1.228.79-2.605,1.373-3.878A5.755,5.755,0,0,1,10.021,0",
    transform: "translate(7.925 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22101",
    "data-name": "Path 22101",
    d: "M0,16.121c5.127,4.011,14.849,4.674,19.805.19A10.009,10.009,0,0,0,22.28,5.159,9.2,9.2,0,0,0,13.588.039,8.712,8.712,0,0,0,5.57,7.6a10.4,10.4,0,0,0,.675,4.929c1.166,3.23.625,4.2-2.8,4.06-1.1-.044-2.194-.292-3.442-.468",
    transform: "translate(0 27.213)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22102",
    "data-name": "Path 22102",
    d: "M21.921,18.149C22.188,11.5,20.836,5.4,14.669,1.579,8.284-2.379.315,1.52.008,8.652A8.8,8.8,0,0,0,4.987,16.92a8.874,8.874,0,0,0,9.747-1.534,19.02,19.02,0,0,0,1.576-1.851c1.541-1.9,2.9-1.826,4.146.31a12.537,12.537,0,0,1,.913,2.245c.229.672.371,1.372.552,2.059",
    transform: "translate(25.662 18.442)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlackIcon);
export default __webpack_public_path__ + "static/media/blackIcon.80d0edca55bf1a605cd2c1f761be60b9.svg";
export { ForwardRef as ReactComponent };